
<template>
  <div>
    <!-- <base-breadcrumb></base-breadcrumb> -->

    <card-loading-transparent v-if="loading"></card-loading-transparent>
    <v-alert type="error" :value="true" v-if="!loading && !one_template.id">
      Houve um erro.
    </v-alert>

    <base-card v-if="!loading && one_template.id" with_divider :with_actions="false">
      <template slot="title">
        <!-- <v-col cols="12"> -->
          <v-menu v-model="menu_color" offset-x width="300px" :close-on-content-click="false" rounded="lg" open-on-hover>
            <template v-slot:activator="{on}">
              <v-btn v-on="on" icon :color="one_template.color">
                <v-icon style="border-radius: 20px;">mdi-square-rounded</v-icon>
              </v-btn>
            </template>
            <v-card width="330px">
              <v-card-text>
                <v-color-picker 
                  v-model="color"
                  dot-size="25"
                  hide-sliders
                  hide-mode-switch
                  mode="hexa"
                  show-swatches
                  swatches-max-height="200"
                  :value="the_color"
                  :disabled="!$can('update', new entities.Project(one_template.use_type, one_template.status))"
                ></v-color-picker>
              </v-card-text>
            </v-card>
          </v-menu>
          <v-text-field
            ref="template_name"
            :placeholder="$t('templates.name_form_label')"
            solo flat class="black--text" style="font-weight: 900 !important; font-size: large !important;"
            v-model="one_template.name" dense hide-details
            :rules="required"
            @change="updateTemplateField('name')"
            @blur="handleBlur($event, 'name', 'template_name')"
            :disabled="!$can('update', new entities.Project(one_template.use_type, one_template.status))"
            @focus="handleFocus"
          ></v-text-field>
        <!-- </v-col> -->
      </template>
      <template slot="btn-slot">
        <v-btn color="primary" small class="white--text elevation-0 text-capitalize" :disabled="!$can('update', new entities.Project(one_template.use_type, one_template.status))" @click="addStage()">
          <v-icon left small >mdi-plus</v-icon>
          {{ $t('stages.new') }}
        </v-btn>
      </template>
      <template v-slot:content>
        <v-row align="center" class="pa-3" >
          <b class="subtitle-1 black--text mb-7 mr-2"> {{ $t('projects.kind') }}: </b>
          <v-col cols="7" class="pa-0">
            <v-text-field filled rounded
              class="rounder" dense
              v-model="one_template.kind"
              :rules="required"
              @change="updateTemplateField('kind')"
              :disabled="!$can('update', new entities.Project(one_template.use_type, one_template.status))"
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
    </base-card>


      <stages-template-list></stages-template-list>

    <dialog-new-stage v-if="new_stage" :max_positions="one_template.stage_count + 1" :position="stage_position"
      @done="handleDoneStage" 
      @cancel="handleCancelStage"
    ></dialog-new-stage>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import request_error_catch from '@/mixins/request_error_catch'
import Api from '@/api/index';
import TemplateStagesList from './stages/TemplateStagesList.vue';
import DialogNewStage from './control/DialogNewStage.vue';
import entities from '@/utils/entities';


// console.log(entities)
export default {
  name: 'OneTemplate',
  mixins: [ validations, request_error_catch ],
  components: {
    StagesTemplateList: TemplateStagesList,
    DialogNewStage
    //ComponentName: () => import(''),
  },
  data() {
    return {
      loading: false,
      one_template: {},
      one_template_bkp: {},

      entities: entities,

      new_stage: false,
      stage_position: null,

      the_color: null,
      menu_color: false,
    }
  },
  methods: {
    addStage(){
      this.new_stage = true
      this.stage_position = this.one_template.stage_count + 1
    },
    handleDoneStage(e){
      console.log({e});
      e = {
        ...e,
        project_id: this.one_template.id,
        company_id: this.one_template.company_id,
      }

      this.createStage(e)
    },
    handleCancelStage(e){
      this.new_stage = false
      this.stage_position = null
    },
    createStage(stage){
      this.loading = true
      Api.Stage.create(stage).then(r=> r.data).then(d=> {
        this.$refs.template_stage_list.getStages()
        this.handleCancelStage()
      }).catch(err=> {
        console.log({err});
        this.catch_error(err)
      }).finally(() => this.loading = false)
    },
    handleFocus(e){
      console.log({e});
      // const text_field = e.target.parentElement.parentElement.parentElement.parentElement
      // console.log({text_field});
      // text_field.classList.add("mb-2")
      this.$refs.template_name.outlined = true
    },
    handleBlur(e, field, ref){
      const {target: {validity: {valid}, validationMessage, _value} } = e
      // console.log({e, tg: e.target, vld: e.target.validity, valid});
      const text_field = e.target.parentElement.parentElement.parentElement.parentElement
      // console.log({text_field, pc: text_field._prevClass});

      let is_valid = true

      // console.log(this.$refs[ref]);

      if (!valid || text_field._prevClass.includes('error--text')){
        is_valid = false
      }

      if (ref && ref == 'template_name'){
        this.$refs.template_name.outlined = false
      }
      
      if(!is_valid){
        let msg = validationMessage || text_field.textContent 
        if (!msg && ref){
          msg = this.$refs[ref].messagesToDisplay
        } else if (!msg && !ref){
          msg = 'Houve um erro.'
        }
        text_field.classList.add("rounder_error")
        // e.target.parentElement.parentElement.parentElement.parentElement.classList.add("")
        // e.target.placeholder = 'Template needs a name'
        this.addNotification({type: 'error', msg})
      } else {
        // console.log('ee', field);
        // this.updateStageField(field, _value)
      }
    },
    getTemplateProject() {
      this.loading = true
      Api.Project.show(this.$route.params.id).then(r=>r.data).then(d=> {
        console.log({d});
        this.one_template = {
          ...d,
          color: d.json_attributes.color
        }
        this.one_template_bkp = {...d}
        this.the_color = this.one_template.color
      }).catch((err)=> {
        console.log({err});
        this.catch_error(err)
      }).finally(()=> this.loading = false)
    },
    updateTemplateField(field){
      if (this.one_template[field]){
        let obj = {
          id: this.$route.params.id,
        }
        obj[field] = this.one_template[field]
        Api.Project.update(obj).then(r=>r.data).then(d=> {
          this.one_template = {
            ...d,
            color: d.json_attributes.color
          }
          this.addNotification({msg: 'Atualizado com sucesso', type: 'success'})
        }).catch(err=> {
          console.log({err});
          this.catch_error(err)
          this.addNotification({type: 'error', msg: err})
        }).finally(()=>{

        })
      } else {

      }
    },
    ...mapActions({
      // function: 'Module/action'
      addNotification: 'Notification/add'
    })
  },
  computed: {
    color: {
      get () {
        return this.the_color
      },
      set (v) {
        this.the_color = v
        this.one_template.color = v
      },
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  mounted () {
    this.getTemplateProject();
  },
  watch: {
    the_color(nv,ov) {
      if (nv){
        this.one_template.color = nv
      } else if (nv == false){
    
      }
    },
    menu_color(nv,ov) {
      if (nv == false){
        if (this.one_template.color != this.one_template.json_attributes.color){
          this.updateTemplateField('color')
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>

::v-deep.rounder_error.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot {
  color: #ff00FF !important;
  // background-color: #ff0000;
  /* min-height: 30px !important; */
}
::v-deep.rounder_error.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot ::placeholder {
  color: #ff0000 !important;
  // background-color: #ff0000;
  /* min-height: 30px !important; */
}
</style>